export const namespaced = true

import BaseStore from '@/store/baseDikeTrajectoryStore'
import api from '../api/api'

const baseURI = '/dike_profiles/'
const baseStore = new BaseStore(baseURI)

const getDefaultState = () => {
  return {
    ...baseStore.state,
    status: 'empty',
    dikeProfilesElevation: [],
    loadingElevation: false,
    singleProfiles: false,
    expand: false,
    showElevationProfiles: false,
    xRange: [-100, 100],
    yRange: [-5, 20],
    showOverview: false,
    selectedStabSchematisationStageId: null,
    fetchedDikeSections: []
  }
}

export const state = getDefaultState()

export const mutations = {
  ...baseStore.mutations,
  resetState(state) {
    Object.assign(state, getDefaultState())
  },
  SET_DIKE_PROFILES_ELEVATION(state, payload) {
    state.dikeProfilesElevation.push(...payload)
  },
  SET_FETCHED_DIKE_SECTIONS(state, id) {
    state.fetchedDikeSections.push(id)
  },
  TOGGLE_LOADING_ELEVATION(state) {
    state.loadingElevation = !state.loadingElevation
  },
  TOGGLE_SINGLE_PROFILES(state) {
    state.singleProfiles = !state.singleProfiles
  },
  TOGGLE_EXPAND(state) {
    state.expand = !state.expand
  },
  TOGGLE_SHOW_ELEVATION_PROFILES(state, bool) {
    state.showElevationProfiles = bool
  },
  TOGGLE_SHOW_OVERVIEW(state, showOverview) {
    state.showOverview = showOverview
  },
  SET_SELECTED_STAB_SCHEMATISATION_STAGE_ID(state, stabSchematisationStageId) {
    state.selectedStabSchematisationStageId = stabSchematisationStageId
  }
}

export const actions = {
  ...baseStore.actions,
  resetState({ commit }) {
    commit('resetState')
  },
  async fetchDikeProfilesElevation(context, dikeSectionId) {
    context.commit('TOGGLE_LOADING_ELEVATION')

    try {
      if (!context.state.fetchedDikeSections.includes(dikeSectionId)) {
        context.commit('SET_FETCHED_DIKE_SECTIONS', dikeSectionId)
        let response = await api.get(`dike_profiles_elevation/?search=${dikeSectionId}`)
        const data = 'features' in response.data ? response.data['features'] : null
        if (data) {
          context.commit('SET_DIKE_PROFILES_ELEVATION', data)
        }
      }
    } catch (e) {
      console.log(e)
    }

    context.commit('TOGGLE_LOADING_ELEVATION')
  },
  async updateElevation(context, payload) {
    await api.put(
      `${context.state.baseUrl}${context.rootState.project.currentProject.id}/update_elevation/`,
      payload
    )
  },
  async toggleSingleProfiles({ commit }) {
    commit('TOGGLE_SINGLE_PROFILES')
  },
  setCurrentItem(context, payload) {
    if (context.state.loadingElevation) {
      console.log('already loading')
      return
    }
    context.commit('SET_CURRENT_ITEM', payload)
    context.dispatch('dikeSection/checkCurrentItem', null, { root: true })
  },
  async checkCurrentItem(context) {
    if (
      context.state.currentItem &&
      context.state.currentItem.properties.dikesection_id !==
        context.rootState.dikeSection.currentItem?.id
    ) {
      context.commit('SET_CURRENT_ITEM', null)
    }
  },
  async toggleExpand({ commit }) {
    commit('TOGGLE_EXPAND')
  },
  async toggleShowElevationProfiles({ commit, state }, bool) {
    if (bool && state.showOverview) {
      commit('TOGGLE_SHOW_OVERVIEW', false)
    }
    commit('TOGGLE_SHOW_ELEVATION_PROFILES', bool)
  },
  toggleShowOverview({ state, commit }, showOverview) {
    if (showOverview && state.showElevationProfiles) {
      commit('TOGGLE_SHOW_ELEVATION_PROFILES', false)
    }
    commit('TOGGLE_SHOW_OVERVIEW', showOverview)
  },
  setSelectedStabSchematisationStageId({ commit }, stabSchematisationStageId) {
    commit('SET_SELECTED_STAB_SCHEMATISATION_STAGE_ID', stabSchematisationStageId)
  }
}

export const getters = {
  getDikeProfileFromId: (state) => (id) => {
    return state.items?.features.find((dikeProfile) => dikeProfile.id === id)
  },
  getDikeProfileFromEvent: (state, getters) => (e) => {
    return getters.getDikeProfileFromId(e.features[0].properties.geometry_id)
  },
  getDikeProfiles: (state, getters, rootGetters) => {
    return rootGetters['referencePoint/getReferencePointFromId']
      ? rootGetters['referencePoint/getReferencePointFromId']
          .map((referencePoint) => referencePoint.properties.dikeprofile_set.features)
          .flat()
      : null
  },
  getOffset: (state) => {
    return state.showElevationProfiles && !state.singleProfiles && !state.expand
      ? [-200, 0]
      : [0, 0]
  },
  currentDikeProfilesElevation: (state, getters, rootState) => {
    return state.dikeProfilesElevation.filter((item) => {
      return (
        item?.properties?.dikesection_id &&
        item.properties.dikesection_id === rootState.stabSchematisation.currentOverviewItem?.id
      )
    })
  },
  leafletItems: (state) => {
    if (!state.items?.features) {
      return null
    }
    const features = JSON.parse(JSON.stringify(state.items?.features))

    features?.forEach((feature) => {
      if (feature.geometry && feature.geometry.coordinates) {
        feature.geometry.coordinates.forEach((coord) => {
          if (Array.isArray(coord) && coord.length >= 2) {
            // Swap the values at index 0 and index 1
            ;[coord[0], coord[1]] = [coord[1], coord[0]]
          }
        })
      }
    })
    return features
  }
}
